module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<h3 class=\"title\"><a role=\"button\" class=\"switch\" data-toggle=\"collapse\" data-target=\"#attributes-options\">Attributes <i class=\"fa pf-carot-down\"></i></a></h3>\r\n<div id=\"attributes-options\" class=\"collapse in\">\r\n    <ul class=\"attribute-options\">\r\n        <div id=\"propMainName\" class=\"prop-main-name style-text prop-detail\"></div>\r\n        <div id=\"propMainText\" class=\"prop-main-text style-text prop-detail\"></div>\r\n        <div id=\"propMainFormName\" class=\"prop-main-form-name style-text prop-detail\"></div>\r\n        <div id=\"propMainCaption\" class=\"prop-main-caption prop-detail\"></div>\r\n    </ul>\r\n</div>")
  }
  return __output;

}